import { FC } from 'react'
import { CalendarDot } from '@phosphor-icons/react'

import { IconPropsType } from '~/src/components/generic/PhosphorIcons/types'

const Icon: FC<IconPropsType> = ({ color, size, weight, mirrored }) => (
  <CalendarDot color={color} size={size} weight={weight} mirrored={mirrored} />
)

export default Icon
